/** basic.entityManage */
export default {
    entity_name: "Название организации",
    entity_namePla: "Введите название организации",
    entity_addr: "Адрес организации",
    entity_addrPla: "Введите адрес организации",
    entity_platformName: "Название платформы",
    entity_platformNamePla: "Введите название платформы",
    entity_coding: "Код организации",
    entity_details: "Детали",
    entity_addJunior: "Добавить подчинённую",
    entity_drawerTitle: "Детали организации",
    entity_entityNews: "Информация об организации",
    entity_confirmEdit: "Подтвердить изменения",
    entity_logo: "Логотип организации",
    entity_addEntity: "Добавить организацию",
    entity_platformLogo: "Логотип платформы",
    entity_superiorsName: "Вышестоящая организация",
    entity_oneImg: "Можно загрузить только один логотип!",
    agency_proxy: "Агент",
    tab_billboard: "Рекламный щит",
}

